"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETUP_STEP_MAPPER = void 0;
var interfaces_1 = require("@hudled/interfaces");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var AddConnectionModal_1 = __importDefault(require("containers/Settings/Integrations/NewConnection/AddConnectionModal"));
var constants_1 = require("../constants");
var AccountCodesDropdown_1 = __importDefault(require("./Dropdowns/AccountCodesDropdown"));
var ForwardingAddress_1 = __importDefault(require("./LinkCopier/ForwardingAddress"));
var AutoEmailForwarding_1 = __importDefault(require("./ModalComponents/AutoEmailForwarding"));
var BillingMethodModal_1 = __importDefault(require("./ModalComponents/BillingMethodModal"));
var BillingTermsModal_1 = __importDefault(require("./ModalComponents/BillingTermsModal"));
var EmailHeadersModal_1 = __importDefault(require("./ModalComponents/EmailHeadersModal"));
var UploadInvoice_1 = __importDefault(require("./ModalComponents/UploadInvoice"));
var VendorEmail_1 = __importDefault(require("./ModalComponents/VendorEmail"));
exports.SETUP_STEP_MAPPER = {
    CONNECT_ACCOUNTING: {
        label: 'Connect your Accounting Platform',
        ModalComponent: AddConnectionModal_1.default,
    },
    UPLOAD_XERO_FILE: {
        label: 'Upload your latest Xero invoice',
        ModalComponent: (0, DefaultPropsHoC_1.default)(UploadInvoice_1.default, { vendor: 'Xero' }),
    },
    SETUP_EMAIL_FWD: {
        label: 'Setup Email Forwarding',
        stepConf: { strikethrough: false },
        subSteps: interfaces_1.RECHARGES_SETUP_EMAIL_FWD_SUB_STEPS,
        subStepsMap: {
            SETUP_FWD_ADDRESS: {
                label: 'Your forwarding address',
                StepComponent: ForwardingAddress_1.default,
                stepConf: { strikethrough: false },
            },
            SEND_XERO_INVOICE_EMAIL: {
                label: 'Send your latest **Xero Invoice Email**',
                ModalComponent: VendorEmail_1.default,
                stepConf: { strikethrough: false },
                getStatus: function (rechargerCompany) { return rechargerCompany.firstInvoiceEmailStatus
                    ? constants_1.RECHARGES_MAIL_STATUS_MAPPER[rechargerCompany.firstInvoiceEmailStatus]
                    : { status: 'default', text: 'to above address' }; },
            },
            SETUP_GMAIL_AUTO_FWD: {
                label: 'Setup automatic email forwarding',
                ModalComponent: AutoEmailForwarding_1.default,
                stepConf: { strikethrough: false },
            },
        },
    },
    /* TEMP STEPS FOLLOW */
    MAP_CUST_TO_ORGS: {
        label: 'Map Customers to Organisations',
        to: '/recharges/mapping/for-review',
    },
    CONNECT_CLIENT_XEROS: {
        label: 'Connect your Clients’ Xero Accounts',
        to: '/recharges/connections',
    },
    /* Eo TEMP STEPS */
    ENABLE_AUTO_RECHARGES: {
        label: 'Enable Automatic Billing of Recharges',
        stepConf: { strikethrough: false },
        subSteps: interfaces_1.RECHARGES_ENABLE_AUTO_RECHARGES_SUB_STEPS,
        subStepsMap: {
            SET_ACC_CODE: {
                label: 'Select accounting code',
                StepComponent: AccountCodesDropdown_1.default,
                infoTooltip: 'The accounting code to be passed to Xero for this recharge',
                stepConf: { strikethrough: false },
            },
            SET_BILLING_METHOD: {
                label: 'Select billing method',
                ModalComponent: BillingMethodModal_1.default,
                stepConf: { strikethrough: false },
            },
            DEFINE_BILLING_TERMS: {
                label: 'Define billing terms',
                ModalComponent: BillingTermsModal_1.default,
                stepConf: { strikethrough: false },
            },
            SET_EMAIL_HEADERS: {
                label: 'Add Email Headers (CC & Reply-To)',
                ModalComponent: EmailHeadersModal_1.default,
                stepConf: { strikethrough: false },
            },
            SET_AUTO_RECHARGING: {
                label: 'Enable First Batch of Automatic Recharging',
                to: '/recharges/billing/customers',
                stepConf: { strikethrough: false },
            },
        },
    },
};
